import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const CpdLandingStyle = withTheme(styled.div`
  max-width: 1182px;
  margin: 40px auto;
  padding: 0px 20px;
  .circle {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background-color: #164843;
    color: #fff;
    text-align: center;
    padding-top: 8px;
    font-size: 24px;
    line-height: 24px;
    margin-top: 6px;
  }
  .img-4step {
    margin-top: 20px;
    width: 381px;
    height: 227px;
  }
  .col2 {
    margin-top: 30px;
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .col1 {
      text-align: center;
    }
    .img-4step {
      margin: auto;
      margin-top: 20px;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('md')} {
    padding: 0px 16px;
    .topic {
      font-size: 24px;
      line-height: 24px;
    }
    .img-4step {
      width: 279px;
      height: 166px;
    }
    .col2 {
      margin-top: 0px;
    }
  }
`);

export default CpdLandingStyle;
